export default text => {
  return typeof text === 'string' ? text.replace(/\n/g, '<br />') : text;
};
